import { render, staticRenderFns } from "./DetailSidebar.vue?vue&type=template&id=cb0a8f8e&scoped=true&"
import script from "./DetailSidebar.vue?vue&type=script&lang=ts&"
export * from "./DetailSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./DetailSidebar.vue?vue&type=style&index=0&id=cb0a8f8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0a8f8e",
  null
  
)

export default component.exports